import Index from "../../pages/snail/doubleFestival/index";
import PC from "../../pages/snail/doubleFestival/pc";

const base = "doubleFestival";

const routes = [{
        path: `/${base}/index*`,
        name: `${base}-index`,
        component: Index
    },
    {
        path: `/${base}/enter*`,
        name: `${base}-enter`,
        component: Index
    },
    {
        path: `/${base}/pc*`,
        name: `${base}-pc`,
        component: PC
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/snail/doubleFestival.js